import { render, staticRenderFns } from "./WelcomeToTheMoonScoresByAdventure.vue?vue&type=template&id=c0776de8"
import script from "./WelcomeToTheMoonScoresByAdventure.vue?vue&type=script&lang=ts"
export * from "./WelcomeToTheMoonScoresByAdventure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports